import { render, staticRenderFns } from "./EditComment.vue?vue&type=template&id=121b115f&scoped=true"
import script from "./EditComment.vue?vue&type=script&lang=js"
export * from "./EditComment.vue?vue&type=script&lang=js"
import style0 from "./EditComment.vue?vue&type=style&index=0&id=121b115f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b115f",
  null
  
)

export default component.exports